import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import Rotas from './rotas';
import { RecoilRoot, atom, useRecoilValue } from 'recoil'
import { userState } from './service/database'
import { ToastProvider } from 'react-toast-notifications';
import {ConfigProvider} from 'antd'

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ConfigProvider
      theme={{
        token: {
          // Seed Token, affects wide range
          colorPrimary: '#1a365c',
         
        },
        components:{
          Button:{
            colorPrimary: '#1a365c',
          }
        }
      }}
    >
      <ToastProvider placement='top-right' style={{ zIndex: 9999999999999 }} zIndex={9999999999999}>
        <RecoilRoot>
          <Rotas />
        </RecoilRoot>
      </ToastProvider>
    </ConfigProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
